import React__default from 'react';
import PropTypes from 'prop-types';
import { n as nodeOrStringProp } from './PropTypes-e1e509ba.js';
import 'moment';

function Container(props) {
  var children = props.children,
    compact = props.compact,
    className = props.className;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-container ".concat(compact ? 'bf-container-compact' : '', " ").concat(className)
  }, children);
}
Container.defaultProps = {
  compact: false,
  className: ''
};
Container.propTypes = {
  /**
  Container content
   */
  children: nodeOrStringProp.isRequired,
  /**
  Container with an smaller width
   */
  compact: PropTypes.bool,
  /**
  Custom className
   */
  className: PropTypes.string
};

export default Container;
//# sourceMappingURL=Container.js.map
